module.exports = __webpack_public_path__ + "static/media/slidebrowser2.eb79987b.png";